<svg width="16" xmlns="http://www.w3.org/2000/svg" height="16" id="screenshot-e78f9450-6853-804e-8007-f8c50421461c" viewBox="0 0 16 16" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1">
  <path d="M2,5L2,2L6,2M10,2L14,2L14,5M14,11L14,14L10,14M6,14L2,14L2,11" stroke="currentColor" />
  <path d="M7,8L1,8" stroke="currentColor" />
  <path d="M3,10L1,8L3,6" stroke="currentColor" />
  <path d="M13,6L15,8L13,10" stroke="currentColor" />
  <path d="M9,8L15,8" stroke="currentColor" />
</svg>